import { Injectable } from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import { TrendingActions } from './trending.actions';
import { ChartSelectedProperties, TrendingResolution, TrendingType } from './trending.model';
import { TrendingSelectors } from './trending.selectors';

@Injectable({ providedIn: 'root' })
export class TrendingStore {
  state$ = this.store.select(TrendingSelectors.getState());
  dateRange$ = this.store.select(TrendingSelectors.getDateRange);
  resolution$ = this.store.select(TrendingSelectors.getResoultion);
  dataSeries$ = this.store.select(TrendingSelectors.getDataSeries());
  dateseriesError$ = this.store.select(TrendingSelectors.getDateseriesError());
  enumPropertiesMapping$ = this.store.select(TrendingSelectors.getEnumPropertiesMapping);
  navigatorMin$ = this.store.select(TrendingSelectors.getNavigatorMin);
  navigatorMax$ = this.store.select(TrendingSelectors.getNavigatorMax);
  powerTrendingChartsLabel$ = this.store.select(TrendingSelectors.selectPowerTrendingChartsLabel);
  stateOfChargeLabel$ = this.store.select(TrendingSelectors.selectStateOfChargeLabel);
  selectBatteryModuleVoltageLabel$ = this.store.select(
    TrendingSelectors.selectBatteryModuleVoltageLabel
  );
  selectTemperaturesLabel$ = this.store.select(TrendingSelectors.selectTemperaturesLabel);
  selectTrendingTabData$ = this.store.select(TrendingSelectors.selectTrendingTabData);
  isAllowedToShowViUnifyButton$ = this.store.select(
    TrendingSelectors.selectIsAllowedToShowViUnifyButton
  );

  constructor(private store: Store) {}

  getDataSeries(): void {
    this.store.dispatch(TrendingActions.getDataSeries());
  }

  selectChartProperties(chartProperties: ChartSelectedProperties): void {
    this.store.dispatch(TrendingActions.selectChartProperties({ chartProperties }));
  }

  getChartSelectedProperties(chartName: string): Observable<ChartSelectedProperties> {
    return this.store.select(TrendingSelectors.getChartSelectedProperties(chartName));
  }

  clearTrendingStore(): void {
    this.store.dispatch(TrendingActions.clearStore());
  }

  setDateRange(dateRange: DateRange<Date>): void {
    this.store.dispatch(TrendingActions.setDateRange({ dateRange }));
  }

  setResolution(resolution: TrendingResolution): void {
    this.store.dispatch(TrendingActions.setResolution({ resolution }));
  }

  setNavigatorExtremes(min: number, max: number): void {
    this.store.dispatch(TrendingActions.setNavigatorExtremes({ min, max }));
  }

  selectTrendingTabData(): void {
    this.store.dispatch(TrendingActions.selectTrendingTabData.attempt());
  }

  setActiveTrendingType(trendingType: TrendingType): void {
    this.store.dispatch(TrendingActions.setActiveTrendingType({ trendingType }));
  }

  getEnergyStorageLabels(): void {
    this.store.dispatch(TrendingActions.getEnergyStorageLabels.attempt());
  }
}
